export const truncateText = (text: string, limit: number) => {
  return `${text?.slice(0, limit)} ${text?.length > limit ? '...' : ''}`
}